module.exports = __webpack_public_path__ + "img/luyin.42e99e21.png";